<!-- 服务特色-->
<template>
<div class="features" v-if="topicTags.length>0 || customTags.length>0">
    <h3 class="detail-header">服务特色</h3>
    <ul class="detail-tag__list">
        <li class="detail-tag__item" v-for="(item, i) in topicTags" :key="`topic-${i}`">
        {{ item.name }}
        </li>
        <li class="detail-tag__item" v-for="(item, i) in customTags" :key="`custom-${i}`">
        {{ item.name }}
        </li>
    </ul>
</div>
</template>
<script>
export default {
    name:'InfoServerFeawtures',
    props:{
        topicTags:{
            type:Array,
            default:[],
        },
        customTags:{
            type:Array,
            default:[],
        }
    },
    data(){
        return{

        }
    }
}
</script>
<style lang="scss" scoped>
.features{

    .detail-header {
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 20px;
    }
    .detail-tag__list {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 20px;
    }
    .detail-tag__item {
      line-height: 30px;
      padding: 0 10px;
      background: #f8f8f8;
      border-radius: 4px;
      font-size: 14px;
      color: var(--text-color-3);
      margin-right: 10px;
      margin-bottom: 10px;
    }
}
</style>